<template>
  <div class="searchBox">
    <!-- <div class="select-box">
      <div
        class="select-box-item"
        :class="{ selectBoxAcvtive: selectBoxValue == '1' }"
        @click="selectBox('1')"
      >
        图片寻人
      </div>
      <div
        class="select-box-item"
        :class="{ selectBoxAcvtive: selectBoxValue == '2' }"
        @click="selectBox('2')"
      >
        线索摸排
      </div>
    </div> -->
    <div class="select-content" v-if="selectBoxValue == '1'">
      <div class="select-content-body">
        <div class="search-content-title">查询图片</div>
        <div class="search-box-content-img">
          <!-- <el-upload
            class="uploadStyle"
            ref="uploadRef"
            list-type="picture-card"
            :show-file-list="false"
            :action="'/apiData/hz-data-community/zghz/znyy/vids/feature/all'"
            :http-request="changeRequest"
            :headers="{
              token: token,
            }"
          >
            <img v-if="imageUrl" :src="imgURL + imageUrl" alt="" />
            <i v-else :style="iconStyle" class="iconfont icon-tianjia1"></i>
          </el-upload> -->
          <el-upload
            class="uploadStyle"
            ref="uploadRef"
            list-type="picture-card"
            drag
            :file-list="fileList"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handleBeforeUpload"
          >
            <img v-if="imageUrl" :src="imgURL + imageUrl" alt="" />
            <i v-else :style="iconStyle" class="iconfont icon-tianjia1"></i>
          </el-upload>

          <div class="img" v-show="searchParams.image">
            <el-popover
              v-model:visible="popperVisible"
              popper-class="popoverTabel"
              width="577px"
              placement="right-end"
              :offset="30"
            >
              <template #reference>
                <img
                  :src="
                    searchParams.imageList && searchParams.imageList[0]
                      ? searchParams.imageList[0].url
                      : searchParams.image
                  "
                  style="width: 100%; height: 100%"
                  alt=""
                />
              </template>
              <div class="popperContent">
                <div class="popperContent-title">
                  检索图片：{{ searchParams.imageList.length }}
                </div>
                <div class="popperContent-img">
                  <div
                    class="popperContent-img-item"
                    v-for="(item, index) in searchParams.imageList"
                    :key="index"
                  >
                    <h-icon
                      icon="icon-guanbi2"
                      @click="deleteImge(index)"
                    ></h-icon>
                    <img
                      :src="item.url"
                      style="width: 70px; height: 75px; margin-left: 15px"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </el-popover>
          </div>
          <div class="search-box-content-btn">
            <el-button
              v-for="item in searchImageSelect"
              :key="item.value"
              @click="clicksearchImageSelect(item.value)"
              :class="{
                searchImageSelectStyle:
                  searchParams.searchImageSelectData == item.value,
              }"
              >{{ item.name }}</el-button
            >
          </div>
        </div>
        <div
          class="search-content-title"
          v-if="
            (searchParams.searchImageSelectData == '1' ||
              searchParams.searchImageSelectData == '0') &&
            searchParams.image
          "
        >
          相似度≥
        </div>
        <h-slider
          v-if="
            (searchParams.searchImageSelectData == '1' ||
              searchParams.searchImageSelectData == '0') &&
            searchParams.image
          "
          v-model:silderNum="searchParams.threshold"
        ></h-slider>

        <div class="search-content-title">搜索特征</div>
        <el-button style="width: 95%" @click="selectFeature">{{
          selectFeatureLen.length > 0
            ? `已选择${selectFeatureLen.length}个特征`
            : "选择特征"
        }}</el-button>
        <div class="search-content-title">搜索范围</div>
        <div class="search-range">
          <el-button
            v-for="(item, index) in searchRangeList"
            :key="index"
            :class="{ isGetSource: item.list.length > 0 }"
            :disabled="item.disabled"
            @click="handleSearchRange(item)"
          >
            <div>
              <div>{{ item.name }}</div>
              <div v-if="item.list.length > 0">{{ item.list.length }}个</div>
            </div>
          </el-button>
        </div>
        <div class="search-content-title">搜索时间</div>
        <div class="search-content-time">
          <div class="search-content-time-item">近</div>
          <div
            class="search-content-time-item"
            :class="{ timeActive: num == itme }"
            v-for="(itme, index) in timeData"
            :key="index"
            @click="handleTimeItme(itme)"
          >
            {{ itme }}
          </div>
          <el-input-number
            v-model="num"
            :min="1"
            :max="99"
            style="width: 102px"
          ></el-input-number>
          <div class="search-content-time-item">天</div>
        </div>
        <h-date-timerange
          v-model:end="searchParams.endTime"
          v-model:start="searchParams.startTime"
        >
        </h-date-timerange>
      </div>
      <div class="search-content-query">
        <h-button
          :disabled="allowSearch"
          type="primary"
          v-debounce="searchPerson"
          >查询</h-button
        >
        <h-button @click="resetForm(formRef)">重置</h-button>
      </div>
    </div>
    <div class="searche-clue" v-else>
      <el-input
        v-model="clueTaskName"
        placeholder="请选择"
        clearable
        style="width: 90%"
        @keyup.enter="getClueTasks"
      >
      </el-input>
      <div class="searche-clue-title">
        <span>任务名称</span>
        <span>操作</span>
      </div>
      <div class="task-list">
        <div class="task-list-item" v-for="item in taskList" :key="item.id">
          <div class="task-name" @click="handleTask(item)">
            {{ item.clueTaskName }}
          </div>
          <div class="task-opertion">
            <i class="iconfont icon-shanchu" @click="deleteClueTasks(item)"></i>
            <i class="iconfont icon-paixu" @click="editTasksName(item)"></i>
          </div>
        </div>
      </div>
      <div class="search-content-query">
        <h-button type="primary" @click="getClueTasks">查询</h-button>
        <h-button @click="createTask">新建任务</h-button>
      </div>
    </div>
    <upload-dialog
      v-if="uploadDialogVisible"
      v-model="uploadDialogVisible"
      :fileObj="uploadFile"
      :uploadImg="uploadFileBase64"
      @emitCheckedImg="getCheckedImg"
    ></upload-dialog>
    <task-detail-dialog
      v-model:visible="taskDialogVisible"
      :editTaskInfo="editTaskInfo"
      v-if="taskDialogVisible"
    ></task-detail-dialog>
    <edit-task-dialog
      v-if="editTaskDialogVisible"
      v-model="editTaskDialogVisible"
      :editTaskInfo="editTaskInfo"
    ></edit-task-dialog>
    <select-feature
      v-show="showSelectFeature"
      v-model:visible="showSelectFeature"
      @selectFeature="getFeatureParams"
      v-model:type="selectFeatureType"
    ></select-feature>
    <transfer-application
      v-show="transferVisible"
      v-model:visible="transferVisible"
      v-model:dataType="searchRangeType"
      :title="searchRangeTitle"
      :backMap="true"
      @transferApplicationList="getTransferList"
      @clickMap="getclickMap"
    ></transfer-application>
    <unique-transfer
      v-show="uniqueVisible"
      v-model:visible="uniqueVisible"
      v-model:dataType="searchRangeType"
      :title="searchRangeTitle"
      @videoSource="getTransferList"
    ></unique-transfer>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
  watch,
  ref,
  computed,
  nextTick,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import util from "@util/js";
import moment from "moment";
import uploadDialog from "./uploadDialog.vue";
import taskDetailDialog from "./taskDetailDialog.vue";
import editTaskDialog from "./editTaskDialog.vue";
import uniqueTransfer from "./uniqueTransfer";
import {
  clueTasks,
  clueTasksDel,
  featureallV2,
  batchDetail,
  clueTaskSources,
} from "@/api/smartApplication/smartApplicationApi.js";
import _ from "lodash";
import { url2ToBase } from "@/api/smartApplication/personSearchApi.js";
export default defineComponent({
  name: "searchRangeDialog",
  components: {
    uploadDialog,
    taskDetailDialog,
    editTaskDialog,
    uniqueTransfer,
  },
  props: {
    searchRangeState: {
      type: Object,
      defaule: null,
    },
  },
  emits: ["update:modelValue", "submit", "openSelectCamera"],
  setup(props, context) {
    const router = useRouter();
    const state = reactive({
      token: localStorage.getItem("token"),
      selectBoxValue: "1",
      allowSearch: false,
      iconStyle: {
        fontSize: "48px",
        lineHeight: "91px",
      },
      imageUrl: "",
      imgURL: window.imgURL,
      form: {
        dateValue: [new Date(), new Date()],
      },
      clueTaskName: "",
      editTaskInfo: null, // 传入编辑任务名弹框
      timeData: [1, 3, 7, 30],
      num: 3,
      uploadDialogVisible: false, // 查询图片弹窗
      uploadFile: null, // 查询图片图片对象
      uploadFileBase64: "", // 查询图片转base64
      taskDialogVisible: false,
      editTaskDialogVisible: false,
      showSelectFeature: false, // 特征弹框
      getSelectFeature: {}, // 获取特征对象
      selectFeatureLen: [], // 获取特征对象个数
      fileList: [], // upload中图片
      searchImageSelect: [
        { name: "全部", value: "0" },
        { name: "人脸", value: "1" },
        { name: "人体", value: "2" },
        { name: "机动车", value: "3" },
        { name: "非机动车", value: "4" },
      ],

      taskList: [],

      searchParams: {
        imageList: [],
        startTime: moment(new Date().getTime() - 3600 * 1000 * 24 * 3).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        image: "",
        roi: {
          leftTopX: 0,
          leftTopY: 0,
          rightBtmX: 0,
          rightBtmY: 0,
        },
        endTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        threshold: 75,
        pageNum: 1,
        pageSize: 100,
        searchImageSelectData: "0", // 搜索类型
        sourceIds: [], // 选择的资源id
        orderType: "0", // 排序类型 0：按相似度排序，2:按时间排序,
        orderRule: "desc", // 排序 desc 降序 asc 升序
      }, // 接口请求参数
      time: [new Date(), new Date()],
      popperVisible: false,
      selectFeatureType: "face",
      searchRangeList: [
        { name: "分析任务", value: "任务", list: [], disabled: false },
        { name: "摸排任务", value: "线索", list: [], disabled: false },
        { name: "摄像机", value: "摄像机", list: [], disabled: false },
        { name: "视频文件", value: "视频", list: [], disabled: false },
      ],
      transferVisible: false,
      uniqueVisible: false,
      searchRangeType: "摄像机", // 穿梭框默认展示摄像机数据
      searchRangeTitle: "摄像机选择", // 穿梭框标题
      videoCameraList: [], // 存选择的摄像头
      videoList: [], // 存选择的摄像头
    });
    const refData = toRefs(state);
    const uploadRef = ref();

    watchEffect(() => {
      state.searchParams.sourceIds =
        props.searchRangeState.videoCameraList &&
        props.searchRangeState.videoCameraList.map((item) => {
          return item.deviceId;
        });
      state.searchParams.videoList = props.searchRangeState.videoList;
    });
    watchEffect(() => {
      if (state.num) {
        nextTick(() => {
          handleTimeItme(state.num);
        });
      }
    });
    onMounted(async () => {
      console.log(router.currentRoute, 666666677);
      if (router.currentRoute.value.query.img) {
        if (router.currentRoute.value.query.type) {
          state.searchParams.image = router.currentRoute.value.query.img;
          const image = new Image();
          image.src = router.currentRoute.value.query.img;
          image.onload = () => {
            let obj = {
              roi: {
                x1: 0,
                y1: 0,
                x2: image.width,
                y2: image.height,
              },
              url: router.currentRoute.value.query.img,
              value: router.currentRoute.value.query.type,
            };
            state.searchParams.imageList[0] = obj;
            state.searchParams.searchImageSelectData =
              router.currentRoute.value.query.type;
            setTimeout(() => {
              searchPerson();
            }, 1000);
          };
        } else {
          const params = {
            paths: [router.currentRoute.value.query.img],
          };
          const res = await url2ToBase(params);
          state.searchParams.image = "data:image/jpeg;base64," + res.data[0];
        }
      }
      getClueTasks();
    });
    const showSearchRange = computed(() => {
      for (const item in props.searchRangeState) {
        if (item.length > 0) {
          return true;
        }
      }
    });
    // 点击查询按钮
    const refreshTasks = () => {};
    // 重置
    const resetForm = () => {
      state.time[1] = new Date();
      state.num = 3;
      state.selectFeatureLen = [];
      const arr = ["startTime", "endTime", "threshold"];
      for (const key in state.searchParams) {
        if (!arr.includes(key)) Reflect.deleteProperty(state.searchParams, key);
      }
      state.searchRangeList.forEach((item) => {
        item.list = [];
        item.disabled = false;
      });
      state.searchParams.searchImageSelectData = "0";
      state.selectFeatureType = "face";
      state.searchParams.videoList = [];
      state.searchParams.imageList = [];
      state.searchParams.sourceIds = [];
      context.emit("update:searchRangeState", {});
    };

    // tag切换
    const selectBox = (value) => {
      state.selectBoxValue = value;
    };
    // 搜索特征
    const selectFeature = () => {
      state.showSelectFeature = true;
    };
    // 获取特征选择
    const getFeatureParams = (featureList) => {
      state.getSelectFeature = featureList;
      state.selectFeatureLen = Object.keys(featureList);
      state.searchParams = { ...state.searchParams, ...state.getSelectFeature };
    };

    // 图片寻人查询弹框
    const searchPerson = () => {
      // state.searchRangeList.forEach((item) => {
      //   if (!item.disabled) {
      //     state.searchParams.sourceIds = item.list.map((it) => {
      //       return it.deviceId;
      //     });
      //   }
      // });
      console.log(state.searchParams);
      const val = _.cloneDeep(state.searchParams);
      if (val.imageList && val.imageList.length > 0) {
        val.roi.leftTopX = _.cloneDeep(val.imageList[0].roi.x1);
        val.roi.leftTopY = _.cloneDeep(val.imageList[0].roi.y1);
        val.roi.rightBtmX = _.cloneDeep(val.imageList[0].roi.x2);
        val.roi.rightBtmY = _.cloneDeep(val.imageList[0].roi.y2);
        delete val.roi.x1;
        delete val.roi.x2;
        delete val.roi.y1;
        delete val.roi.y2;
      } else {
        val.roi = {};
      }
      console.log(val, 898989);
      context.emit("clickSearchPerson", val);
    };
    // 时间切换
    const handleTimeItme = (value) => {
      state.num = value;
      state.searchParams.startTime = moment(
        new Date().getTime() - 3600 * 1000 * 24 * value
      ).format("YYYY-MM-DD 00:00:00");
    };
    // 上传图片触发
    const handleBeforeUpload = async (file) => {
      state.uploadFile = file;
      state.uploadFileBase64 = file.url;
      state.uploadDialogVisible = true;
      state.searchParams.image = await util.getBase64(file.raw);
    };
    // 上传图片触发
    const changeRequest = async (fileVal) => {
      const base64 = await util.getBase64(fileVal.file);
      const str = base64.split(",")[1];
      const params = {
        data: str,
        fileName: fileVal.file.name,
      };
      state.uploadDialogVisible = true;
      state.uploadFileBase64 = base64;
      const res = await featureallV2([params]);
      if (res.code == 0) {
        state.uploadFile = res.list;
      }
    };
    // 获取截图照片
    const getCheckedImg = (value) => {
      if (value.length == 0) {
        state.searchParams.image = "";
        return;
      }
      state.searchParams.imageList = value;
      state.searchParams.roi = value[0].roi;
    };
    // 删除截图照片
    const deleteImge = (index) => {
      state.searchParams.imageList.splice(index, 1);
      if (state.searchParams.imageList.length == 0) {
        state.searchParams.image = "";
        state.popperVisible = false;
      }
    };
    // 新建线索弹框
    const handleTask = (item) => {
      state.editTaskInfo = item;
      context.emit("opentaskDetail", item);
      // state.taskDialogVisible = true;
    };
    // 编辑文件名
    const editTasksName = (item) => {
      state.editTaskInfo = item;
      state.editTaskDialogVisible = true;
    };
    // 新建线索弹框
    const createTask = () => {
      context.emit("openMapOperation");
    };
    // 上传图片触发
    const clicksearchImageSelect = (val) => {
      state.searchParams.searchImageSelectData = val;
      if (val == "3") {
        state.selectFeatureType = "car";
      } else {
        state.selectFeatureType = "face";
      }
      // if (val == "0") {
      //   state.searchImageSelectData = ["0"];
      // } else {
      //   if (state.searchImageSelectData.includes(val)) {
      //     const pos = state.searchImageSelectData.indexOf(val);
      //     state.searchImageSelectData.splice(pos, 1);
      //   } else {
      //     state.searchImageSelectData.push(val);
      //     if (state.searchImageSelectData.includes("0")) {
      //       const posAll = state.searchImageSelectData.indexOf("0");
      //       state.searchImageSelectData.splice(posAll, 1);
      //     }
      //   }
      // }

      // const arr = [];
      // state.searchImageSelectData.forEach((item) => {
      //   state.searchImageSelect.forEach((el) => {
      //     if (el.value == item) {
      //       arr.push(el);
      //     }
      //   });
      // });

      // context.emit("selectFeature", state.searchParams.searchImageSelectData);
    };

    // 模糊查询任务接口
    const getClueTasks = async () => {
      const params = {
        clueTaskName: state.clueTaskName,
      };
      const res = await clueTasks(params);
      state.taskList = res.list;
    };
    // 根据ID删除任务接口
    const deleteClueTasks = async (item) => {
      const params = {
        clueTaskId: item.clueTaskId,
      };
      ElMessageBox.confirm("您确认要删除该任务吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await clueTasksDel(params);
      });
    };
    // 搜索范围选择
    const handleSearchRange = (val) => {
      state.searchRangeType = val.value;
      if (val.value == "任务" || val.value == "线索") {
        state.uniqueVisible = true;
      } else {
        state.transferVisible = true;
      }
      state.searchRangeTitle = val.name + "选择";
    };
    // 获取穿梭框点击地图
    const getclickMap = (val) => {
      context.emit("openSelectCamera");
    };
    // 获取穿梭框摄像头数据
    const getTransferList = async (val) => {
      state.searchRangeList.forEach((item) => {
        if (item.value == state.searchRangeType) {
          item.list = val;
          item.disabled = false;
        } else {
          val.length > 0 ? (item.disabled = true) : (item.disabled = false);
        }
      });
      if (val.length == 0) return;
      state.allowSearch = true;
      let source = [];
      if (state.searchRangeType === "任务") {
        const params = {
          ids: val[0] ? [val[0].id] : [],
        };
        const res = await batchDetail(params);
        source = res.list[0].sources;
      } else if (state.searchRangeType === "线索") {
        const params = {
          ids: val[0] ? [val[0].clueTaskId] : [],
        };
        const res = await clueTaskSources(params);
        source = res.data.sourceList;
      } else if (state.searchRangeType === "摄像机") {
        source = val.map((item) => {
          item.sourceId = item.deviceId;
          return item;
        });
      } else if (state.searchRangeType === "视频") {
        source = val.map((item) => {
          item.sourceId = item.fileId;
          return item;
        });
      }
      console.log(source);
      state.searchParams.sourceIds = source.map((item) => {
        return item.sourceId;
      });
      state.allowSearch = false;
    };

    return {
      ...refData,
      resetForm,
      selectBox,
      selectFeature,
      handleTimeItme,
      handleTask,
      getCheckedImg,
      getFeatureParams,
      clicksearchImageSelect,
      createTask,
      getClueTasks,
      deleteClueTasks,
      editTasksName,
      searchPerson,
      deleteImge,
      handleSearchRange,
      handleBeforeUpload,
      getTransferList,
      getclickMap,
      showSearchRange,
      uploadRef,
      // changeRequest,
    };
  },
});
</script>
<style lang="scss" scoped>
.searchBox {
  width: 100%;
  height: 100%;
  position: relative;
  .select-box {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

    .select-box-item {
      width: 40%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      color: #fff;
      border: 1px solid #1abdd9;
    }
    .selectBoxAcvtive {
      background-image: linear-gradient(0deg, #1abdd9, #dfcaca2e);
    }
  }
  .select-content {
    width: 100%;
    height: calc(100% - 20px);
    .select-content-body {
      height: calc(100% - 40px);
      overflow: auto;
      /deep/.el-upload--picture-card {
        width: 91px;
        height: 91px;
      }
      .search-content-title {
        font-size: 14px;
        color: #fcf9f3;
        line-height: 38px;
        box-sizing: border-box;
      }
      .search-range {
        @include flex-row-c-c;
        .el-button {
          width: 25%;
          height: 42px;
          // line-height: 16px;
          // text-align: center;
          // color: #fff;
          // font-size: 14px;
          // cursor: pointer;
          // border: 1px solid #1abdd9;
          div {
            @include flex-col-c-c;
          }
          margin-left: 0px;
          border-radius: 0px;
          // border: 1px solid #1abdd9;
          &:hover {
            background-color: #1d92df;
          }
        }

        .isGetSource {
          background-color: #1d92df;
          color: #fff;
        }
      }
      .search-box-content-img {
        position: relative;
        @include flex-row-sb-c;
        .uploadStyle {
          width: 30%;
          height: 30%;
          :deep(.el-upload-dragger) {
            width: 91px;
            height: 91px;
          }
        }
        .img {
          width: 30%;
          height: 90px;
          padding: 8px;
          border-radius: 5px;
          border: 1px solid #00f6f7;
        }
        .imgPopover {
          position: absolute;
          top: 0;
        }
        .search-box-content-btn {
          width: 30%;
          height: 30%;
          @include flex-col-c-s;
          .el-button {
            width: 70px;
          }
          /deep/.el-button + .el-button {
            margin-left: 0px;
            border-radius: 0;
          }
          .searchImageSelectStyle {
            border: 2px solid #1eb1d1;
            color: #fff;
            background-color: #1d92df;
            // background-image: linear-gradient(-180deg, #2d79ce 8%, #00bffd 90%);
          }
        }
      }
      .search-content-time {
        @include flex-row-c-c;
        .search-content-time-item {
          line-height: 35px;
          width: 34px;
          text-align: center;
          color: #fff;
          cursor: pointer;
        }
        .timeActive {
          background-color: #0ab0f3;
        }
      }
    }
    .search-content-query {
      // position: absolute;
      // bottom: 0px;
      height: 40px;
      width: 100%;
      margin-top: 12px;
      display: flex;
      justify-content: center;
    }
  }
  .searche-clue {
    height: 80%;
    @mixin commont {
      width: 100%;
      margin: 12px 0;
      padding: 0 8px;
    }
    .searche-clue-title {
      background-color: #31466f;
      height: 34px;
      cursor: pointer;
      color: #fff;
      font-size: 14px;
      @include commont;
      @include flex-row-sb-c;
    }
    .task-list {
      height: 80%;
      @include commont;
      .task-list-item {
        height: 34px;
        @include flex-row-sb-c;
        .task-name {
          color: #03e7e9;
          font-size: 14px;
          text-decoration: underline;
          cursor: pointer;
        }
        .task-opertion {
          letter-spacing: 5px;
          cursor: pointer;
        }
      }
    }
    .search-content-query {
      display: flex;
      margin-top: 16px;
      justify-content: space-around;
    }
  }
}
.popoverTabel {
  .popperContent {
    .popperContent-img {
      @include flex-row-s-c;
      .popperContent-img-item {
        position: relative;
        margin-top: 12px;
        i {
          position: absolute;
          top: -6px;
          transform: rotate(0deg);
          right: -17px;
          color: red;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
